import { Component, HostListener, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { DateRange, MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../../core/services/auth.service';
import { AuthUser } from '../../../../../core/models/auth/auth.interface';
import { User } from '../../../../../core/models/user.interface';
import { LoaderService } from '../../../../../core/shared/services/loader.service';
import { ObjectivesService } from '../../../../../core/services/objectives.service';
import { TestsService } from '../../../../../core/services/tests.service';
import { BarPercentagemComponent } from '../../../../../core/shared/ui/bar-percentagem/bar-percentagem.component';
import { STATES_OBJECTIVES, SUBSCRIPTION_TYPES } from '../../../../../core/shared/constants';
import { BaseComponent } from '../../../../../core/shared/base.component';
import { environment } from '../../../../../../environments/environment';
import { CustomDatePickerComponent } from '../../../../../core/shared/components/custom-date-picker/custom-date-picker.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-new-objective',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatInputModule,
    MatIconModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BarPercentagemComponent,
    CustomDatePickerComponent,
    MatDatepickerModule
  ],
  templateUrl: './new-objective.component.html',
  styleUrls: ['./new-objective.component.scss'],
})
export class NewObjectiveComponent extends BaseComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  authUser: AuthUser = this.authService.getAuthUser()!;
  user: User | null = null;
  private objectiveService: ObjectivesService = inject(ObjectivesService);
  private testService: TestsService = inject(TestsService);
  private loader = inject(LoaderService);

  // Propiedades del Objetivo
  nombreObjetivo: string = '';
  descripcionObjetivo: string = '';
  dimensionObjetivo: any | null = null;
  estadoObjetivo: string = '';
  fechaInicioObjetivo: string = '';
  fechaFinObjetivo: string = '';
  actividades: any[] = [];
  porcentaje: number = 0;

  // Propiedades para el modal de evidencia
  showEvidenceModal: boolean = false;
  currentActivity: any = null;
  evidenceFile: File | null = null;
  evidencePreview: string | null = null;
  evidenceFileName: string = '';
  isUploading: boolean = false;

  // Estado de la UI
  editable: boolean = false;
  editableAct: boolean = false;
  isNewActividad: boolean = false;
  newObjetivo: boolean = false;
  selectedElement: any | null = null;
  selectedButton: any | null = null;
  menuPosition = { top: '0px', left: '0px' };
  isDimensionSelected: boolean = false;
  optionsDimensions: any[] = [];
  selectedValue: string | null = null;

  // Formulario Reactivo para Actividades
  activityForm: FormGroup;
  actividadEditable: any | null = null;
  actividadRecibida: any | null = null;

  // Propiedades para responsive
  isResponsive: boolean = false;
  isOpenFormResponsive: boolean = false;
  actividadResponsive: any | null = null;
  isClosing = false;
  indexEditActividadResponsive: number | null = null;

  maxNameLength: number = 100;

  // Contador de caracteres para descripciones
  maxDescriptionLength: number = 200;

  // Propiedades para el modal de confirmación
  mostrarModal: boolean = false;

  // Propiedades para el modal de éxito
  mostrarModalExito: boolean = false;

  // Método para limpiar fechas almacenadas (evitar bucles)
  private clearCachedDates(): void {
    this._activityMaxStartDateForEndDate = '';
  }

  // Propiedades para almacenar fechas específicas (evitar bucles)
  private _activityMaxStartDateForEndDate: string = '';

  // Propiedades para manejo de evidencia
  selectedEvidenceFile: File | null = null;
  evidencePreviewUrl: string | null = null;

  // Propiedades para el modal de confirmación de eliminación
  mostrarModalConfirmacionEliminacion: boolean = false;
  actividadAEliminar: any | null = null;

  // Calendario
  showModalCalendar: boolean = false;
  assignToCalendar: string = '';
  assingToDate: string = '';
  modalCalendarValue: Date | null = null;
  limitsRangeCalendar: DateRange<Date> = new DateRange<Date>(null, null);
  placeholderCalendar: string = "dd/mm/aaaa";

  constructor(private router: Router, private fb: FormBuilder, private cdr: ChangeDetectorRef) {
    super();
    this.activityForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      state: [STATES_OBJECTIVES.EnProgreso.name, Validators.required],
      completed: [false],
      evidence: ['']
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkResponsive();
    this.updateMenuPosition();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.selectedElement && !this.selectedButton?.contains(event.target as Node)) {
      this.closeMenu();
    }
  }

  ngOnInit() {
    this.loadUserData();
    this.getDimensions();
    this.checkResponsive();
    this.actividadRecibida = history.state.objetivo;
    const isEditable = history.state.editable;

    console.log('🔍 ngOnInit - Estado del historial:');
    console.log('📋 actividadRecibida:', this.actividadRecibida);
    console.log('📋 isEditable:', isEditable);

    // Verificar si hay un objetivo válido con ID para determinar si es nuevo o existente
    if (this.actividadRecibida !== null && this.actividadRecibida !== undefined &&
      (this.actividadRecibida._id || this.actividadRecibida.id)) {
      console.log('🔍 Objetivo existente detectado');
      this.newObjetivo = false;
      this.nombreObjetivo = this.actividadRecibida.name;
      this.descripcionObjetivo = this.actividadRecibida.description;
      this.dimensionObjetivo = this.actividadRecibida.dimension.name;
      this.estadoObjetivo = this.actividadRecibida.state;
      this.fechaInicioObjetivo = this.actividadRecibida.start;
      this.fechaFinObjetivo = this.actividadRecibida.end;
      this.actividades = this.actividadRecibida.activities;
      this.porcentaje = this.actividadRecibida.percentage;
      this.selectedValue = this.actividadRecibida.dimension.id.toString();
      this.editable = isEditable;
      this.editableAct = false;
    } else {
      console.log('🔍 Objetivo nuevo detectado');
      this.newObjetivo = true;
      this.estadoObjetivo = STATES_OBJECTIVES.EnProgreso.name;
      this.editable = isEditable;
      // Asegurar que actividadRecibida sea null para objetivos nuevos
      this.actividadRecibida = null;
    }

    console.log('📋 newObjetivo final:', this.newObjetivo);
  }

  private checkResponsive() {
    this.isResponsive = window.innerWidth <= 1200;
  }

  // --- Métodos para Fechas ---
  getFechaParaInput(fecha: string | null | undefined): string {
    // Optimización: evitar logs repetitivos y procesamiento innecesario
    if (!fecha || fecha === '' || fecha === null || fecha === undefined) {
      return '';
    }

    // Convertir a string si no lo es
    const fechaStr = String(fecha).trim();

    if (!fechaStr) {
      return '';
    }

    // Si ya está en formato YYYY-MM-DD, devolverla tal como está
    if (fechaStr.includes('-') && fechaStr.length === 10) {
      return fechaStr;
    }

    // Si está en formato DD/MM/YYYY, convertirla
    if (fechaStr.includes('/')) {
      const parts = fechaStr.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        // Validar que los parts sean válidos
        if (day && month && year && year.length === 4) {
          const converted = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          //console.log('🔍 Fecha DD/MM/YYYY convertida a:', converted);
          return converted;
        } else {
          console.log('🔍 Partes de fecha DD/MM/YYYY inválidas:', parts);
        }
      }
    }

    // Si es una fecha ISO o timestamp, intentar convertirla
    try {
      const date = new Date(fechaStr);
      if (!isNaN(date.getTime())) {
        const converted = date.toISOString().split('T')[0];
        console.log('🔍 Fecha ISO/timestamp convertida a:', converted);
        return converted;
      }
    } catch (error) {
      console.error('Error convirtiendo fecha:', error);
    }

    console.log('🔍 No se pudo convertir la fecha, devolviendo string vacío. Fecha original:', fechaStr);
    return '';
  }

  getFormattedFecha(fecha: string | null | undefined): string {
    if (!fecha || fecha === '') {
      return '';
    }

    // Si ya está en formato DD/MM/YYYY, devolver tal como está
    if (fecha.includes('/')) {
      return fecha;
    }

    // Si está en formato ISO (YYYY-MM-DD), convertir a DD/MM/YYYY
    if (fecha.includes('-')) {
      const [year, month, day] = fecha.split('-');
      if (year && month && day) {
        const formatted = `${day}/${month}/${year}`;
        return formatted;
      }
    }

    // Si no se puede procesar, devolver la fecha original
    return fecha;
  }

  changeFechaObjetivo(event: string, tipo: number): void {
    if (event) {
      const formattedDate = this.getFormattedFecha(event);
      if (tipo === 1) {
        this.fechaInicioObjetivo = formattedDate;
      } else {
        this.fechaFinObjetivo = formattedDate;
      }
      // Limpiar todas las fechas almacenadas para forzar recálculo
      this.clearCachedDates();
      // Forzar detección de cambios
      this.cdr.detectChanges();
    }
  }

  // Función para manejar cambios de fecha en actividades existentes
  onDateChange(newDate: string, actividad: any, field: 'start' | 'end'): void {
    console.log('🔍 onDateChange llamado:');
    console.log('📅 Nueva fecha:', newDate);
    console.log('📅 Campo:', field);
    console.log('📋 Actividad antes:', actividad);

    if (newDate) {
      // Convertir a formato DD/MM/YYYY para mantener consistencia
      const formattedDate = this.getFormattedFecha(newDate);
      actividad[field] = formattedDate;

      // Limpiar fechas almacenadas para forzar recálculo
      if (field === 'start') {
        this._activityMaxStartDateForEndDate = '';
      }
    } else {
      actividad[field] = '';
    }
  }

  // Función para concatenar la URL del backend con la ruta de evidencia
  getEvidenceUrl(evidencePath: string): string {
    if (!evidencePath) return '';

    //console.log('🔍 getEvidenceUrl llamado con:', evidencePath);

    // Si ya es una URL completa (comienza con http), devolverla tal como está
    if (evidencePath.startsWith('http://') || evidencePath.startsWith('https://')) {
      //console.log('🔍 Es URL completa, devolviendo tal como está');
      return evidencePath;
    }

    // Si es base64, devolver tal como está
    if (evidencePath.startsWith('data:image/')) {
      //console.log('🔍 Es base64, devolviendo tal como está');
      return evidencePath;
    }

    // Extraer el nombre del archivo de la ruta
    let filename = evidencePath;
    if (evidencePath.includes('/')) {
      filename = evidencePath.split('/').pop() || evidencePath;
    }
    //console.log('🔍 Filename extraído:', filename);

    // Usar el nuevo endpoint para servir imágenes
    const finalUrl = `${environment.apiUrl}/objectives/evidence/${filename}`;
    //console.log('🔍 URL final generada:', finalUrl);
    return finalUrl;
  }

  // Función para verificar si una imagen es accesible
  async checkImageAccessibility(imageUrl: string): Promise<boolean> {
    try {
      const response = await fetch(imageUrl, { method: 'HEAD' });
      return response.ok;
    } catch (error) {
      console.error('Error verificando acceso a imagen:', error);
      return false;
    }
  }

  // Métodos para manejo de archivos PDF
  private handlePDFForActivity(file: File, actividad: any): void {
    console.log('🔍 Manejando PDF para actividad:', file.name);

    // Convertir el PDF a base64 para almacenamiento
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target?.result as string;
      actividad.evidence = base64String;
      console.log('📄 PDF convertido a base64 para actividad');
    };
    reader.readAsDataURL(file);
  }

  private handlePDFPreview(file: File): void {
    console.log('🔍 Creando preview para PDF:', file.name);

    // Para PDFs, crear un preview especial (no una imagen)
    this.evidencePreviewUrl = `PDF: ${file.name}`;
    console.log('📄 Preview de PDF creado:', this.evidencePreviewUrl);
  }

  // Función para determinar si un archivo es PDF
  isPDFFile(filename: string): boolean {
    if (!filename) return false;
    return filename.toLowerCase().endsWith('.pdf') || filename.includes('application/pdf');
  }



  // Función para abrir preview de PDF
  openPDFPreview(evidence: string): void {
    console.log('🔍 Abriendo preview de PDF:', evidence);

    if (evidence.startsWith('data:application/pdf')) {
      // Si es base64, crear blob y abrir en nueva ventana
      const byteCharacters = atob(evidence.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } else if (evidence.startsWith('PDF:')) {
      // Si es el preview placeholder, mostrar mensaje
      this.alert('📄 Este es un archivo PDF. Para ver el contenido completo, descarga el archivo.');
    } else {
      // Si es una URL del servidor, abrir directamente
      const pdfUrl = this.getEvidenceUrl(evidence);
      window.open(pdfUrl, '_blank');
    }
  }

  // Función para descargar archivos PDF
  downloadPDF(evidence: string, filename: string): void {
    console.log('📥 Descargando PDF:', evidence, 'como:', filename);

    if (evidence.startsWith('data:application/pdf')) {
      // Si es base64, crear blob y descargar
      try {
        const byteCharacters = atob(evidence.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Crear link de descarga
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        console.log('✅ PDF descargado exitosamente como:', filename);
      } catch (error) {
        console.error('❌ Error al descargar PDF base64:', error);
        this.alert('❌ Error al descargar el archivo PDF. Inténtalo de nuevo.');
      }
    } else if (evidence.startsWith('PDF:')) {
      // Si es el preview placeholder, mostrar mensaje
      this.alert('📄 El archivo aún no está disponible para descarga. Guarda la actividad primero.');
    } else {
      // Si es una URL del servidor, descargar desde el backend
      try {
        const pdfUrl = this.getEvidenceUrl(evidence);
        const a = document.createElement('a');
        a.href = pdfUrl;
        a.download = filename;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        console.log('✅ PDF descargado desde servidor:', pdfUrl);
      } catch (error) {
        console.error('❌ Error al descargar PDF desde servidor:', error);
        this.alert('❌ Error al descargar el archivo PDF. Verifica tu conexión e inténtalo de nuevo.');
      }
    }
  }

  // Función para manejar errores de carga de imagen
  async onImageError(event: any): Promise<void> {
    console.error('Error cargando imagen de evidencia:', event);
    const imgElement = event.target as HTMLImageElement;
    const imageUrl = imgElement.src;

    console.log('🔍 URL que falló:', imageUrl);
    console.log('🔍 Evidencia original:', this.actividadEditable?.evidence);
    console.log('🔍 URL generada:', this.getEvidenceUrl(this.actividadEditable?.evidence));

    // Mostrar mensaje de error
    this.alert(`❌ Error: No se pudo cargar la imagen de evidencia.\nURL: ${imageUrl}\n\nVerifica que:\n1. El servidor backend esté funcionando\n2. La imagen exista en el servidor\n3. No haya problemas de CORS`);

    // Opcionalmente, mostrar una imagen de placeholder
    imgElement.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZpbGw9IiM5Q0EzQUYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZW4gbm8gZGlzcG9uaWJsZTwvdGV4dD4KPC9zdmc+';
  }



  // Función para limpiar la ruta de evidencia antes de enviar al backend
  cleanEvidencePath(evidence: string | null): string | null {
    if (!evidence) return null;

    // Si es base64, mantenerlo tal como está
    if (evidence.startsWith('data:image/')) {
      return evidence;
    }

    // Si es una URL completa, extraer solo la ruta relativa
    if (evidence.startsWith('http://') || evidence.startsWith('https://')) {
      const url = new URL(evidence);
      return url.pathname;
    }

    // Si ya es una ruta relativa, mantenerla
    if (evidence.startsWith('/uploads/')) {
      return evidence;
    }

    // Para cualquier otro caso, devolver tal como está
    return evidence;
  }

  // Función para probar manualmente el endpoint de imágenes
  async testImageEndpoint(): Promise<void> {
    if (!this.actividadEditable?.evidence) {
      this.alert('No hay evidencia para probar');
      return;
    }

    const filename = this.actividadEditable.evidence.split('/').pop();
    const testUrl = `${environment.apiUrl}/objectives/evidence/${filename}`;

    console.log('🧪 Probando endpoint de imagen:', testUrl);

    try {
      const response = await fetch(testUrl);
      console.log('✅ Respuesta del endpoint:', response.status, response.statusText);

      if (response.ok) {
        this.alert(`✅ Endpoint funciona correctamente!\nURL: ${testUrl}`);
      } else {
        const errorData = await response.json();
        console.error('❌ Error del endpoint:', errorData);
        this.alert(`❌ Error del endpoint: ${response.status}\n${JSON.stringify(errorData, null, 2)}`);
      }
    } catch (error) {
      console.error('❌ Error de red:', error);
      this.alert(`❌ Error de red: ${error}`);
    }
  }





  // Función para debuggear las actividades y sus evidencias
  debugActividades(): void {
    console.log('🔍 Debug de actividades:');
    console.log('📊 Total de actividades:', this.actividades.length);

    this.actividades.forEach((actividad, index) => {
      console.log(`📋 Actividad ${index + 1}:`, {
        nombre: actividad.name,
        estado: actividad.state,
        completada: actividad.completed,
        evidencia: actividad.evidence,
        evidenciaUrl: this.getEvidenceUrl(actividad.evidence)
      });
    });

    this.alert(`Debug completado. Revisa la consola para ver la información de ${this.actividades.length} actividades.`);
  }

  // --- Métodos para Actividades (Desktop) ---
  agregarActividad() {
    this.isNewActividad = true;
    this.editableAct = true;
    this.activityForm.reset({
      name: '',
      description: '',
      start: '',
      end: '',
      state: STATES_OBJECTIVES.EnProgreso.name,
      completed: false,
    });
  }

  async editarActividad(): Promise<void> {
    // 1. Configurar modo de edición
    this.isNewActividad = false;
    this.editableAct = true;
    this.actividadEditable = this.selectedElement;

    console.log('🔍 Debug editarActividad - INICIO:');
    console.log('📋 Actividad completa seleccionada:', JSON.stringify(this.selectedElement, null, 2));
    console.log('📅 Actividad start tipo:', typeof this.actividadEditable.start);
    console.log('📅 Actividad end tipo:', typeof this.actividadEditable.end);

    // 2. Preparar fechas
    const fechaInicio = this.getFechaParaInput(this.actividadEditable.start);
    const fechaFin = this.getFechaParaInput(this.actividadEditable.end);

    console.log('🔍 Debug editarActividad:');
    console.log('📅 Fecha original inicio:', this.actividadEditable.start);
    console.log('📅 Fecha original fin:', this.actividadEditable.end);
    console.log('📅 Fecha convertida inicio:', fechaInicio);
    console.log('📅 Fecha convertida fin:', fechaFin);

    // 3. Cargar datos en formulario
    this.activityForm.patchValue({
      name: this.actividadEditable.name,
      description: this.actividadEditable.description,
      start: fechaInicio,
      end: fechaFin,
      state: this.actividadEditable.state,
      completed: this.actividadEditable.state === STATES_OBJECTIVES.Terminado.name,
      evidence: this.actividadEditable.evidence ? 'Evidencia existente' : ''
    });

    console.log('🔍 Valores del formulario después de patchValue:');
    console.log('📝 Formulario completo:', this.activityForm.value);

    // 4. Forzar detección de cambios y validar
    setTimeout(() => {
      this.cdr.detectChanges();
      console.log('🔍 Valores después de detectChanges:');
      console.log('📝 start control:', this.activityForm.get('start')?.value);
      console.log('📝 end control:', this.activityForm.get('end')?.value);
    }, 0);

    // 4. Manejar evidencia existente
    if (this.actividadEditable.state === STATES_OBJECTIVES.Terminado.name && this.actividadEditable.evidence) {
      console.log('🔍 Evidencia original:', this.actividadEditable.evidence);
      const evidenceUrl = this.getEvidenceUrl(this.actividadEditable.evidence);
      console.log('🔗 URL completa generada:', evidenceUrl);

      // IMPORTANTE: Establecer evidencePreviewUrl con la URL completa del backend
      this.evidencePreviewUrl = evidenceUrl;
      console.log('📸 evidencePreviewUrl establecido:', this.evidencePreviewUrl);

      this.selectedEvidenceFile = new File([''], 'evidencia_existente.jpg', { type: 'image/jpeg' });

      // Verificar si la imagen es accesible
      const isAccessible = await this.checkImageAccessibility(evidenceUrl);
      if (!isAccessible) {
        console.warn('La imagen de evidencia no es accesible:', evidenceUrl);
        this.alert('⚠️ Advertencia: La imagen de evidencia no se puede cargar. Verifica que el servidor esté funcionando correctamente.');
      }
    } else {
      this.selectedEvidenceFile = null;
      this.evidencePreviewUrl = null;
    }

    // 5. Configurar validación
    if (this.actividadEditable.state === STATES_OBJECTIVES.Terminado.name) {
      this.activityForm.get('evidence')?.setValidators([Validators.required]);
      this.activityForm.get('evidence')?.updateValueAndValidity();
    } else {
      this.activityForm.get('evidence')?.clearValidators();
      this.activityForm.get('evidence')?.updateValueAndValidity();
    }

    // 6. Cerrar menú
    this.closeMenu();
  }

  guardarActividad() {
    // 1. VALIDAR FORMULARIO
    if (this.activityForm.invalid) {
      this.activityForm.markAllAsTouched();
      return;
    }

    const formData = this.activityForm.value;

    // 2. VALIDAR FECHAS DE LA ACTIVIDAD
    const dateValidation = this.validateFullActivityDates(formData.start, formData.end);
    if (!dateValidation.valid) {
      this.alert(dateValidation.message);
      return;
    }

    // 3. VERIFICAR SI LA ACTIVIDAD ESTÁ TERMINADA
    const isTerminada = formData.state === STATES_OBJECTIVES.Terminado.name;

    // 4. OBTENER EVIDENCIA
    let evidencia = null;

    if (isTerminada) {
      // Si está terminada, debe tener evidencia
      if (this.evidencePreviewUrl) {
        // Si es una nueva imagen (base64), se enviará al backend para procesar
        evidencia = this.evidencePreviewUrl;
      } else if (this.actividadEditable?.evidence) {
        // Si es una evidencia existente, usar la ruta relativa que ya está en el backend
        evidencia = this.actividadEditable.evidence;
      } else {
        this.alert('❌ No se puede guardar la actividad. Para marcar como terminada, debes subir una imagen de evidencia.');
        this.activityForm.get('evidence')?.markAsTouched();
        return;
      }
    }

    // 5. CREAR OBJETO ACTIVIDAD
    console.log('🔍 Guardando actividad con fechas:');
    console.log('📅 Start:', formData.start, 'tipo:', typeof formData.start);
    console.log('📅 End:', formData.end, 'tipo:', typeof formData.end);

    const nuevaActividad = {
      name: formData.name,
      description: formData.description,
      start: formData.start, // Las fechas ya están en formato DD/MM/YYYY
      end: formData.end,     // Las fechas ya están en formato DD/MM/YYYY
      state: formData.state,
      completed: isTerminada,
      evidence: evidencia
    };

    // 6. GUARDAR EN ARRAY
    if (this.isNewActividad) {
      this.actividades.push(nuevaActividad);
    } else {
      const indice = this.actividades.findIndex(act => act === this.actividadEditable);
      if (indice !== -1) {
        this.actividades[indice] = nuevaActividad;
      }
    }

    // 7. LIMPIAR Y FINALIZAR
    this.limpiarFormularioActividad();
    this.calcularPorcentaje();
  }

  limpiarFormularioActividad() {
    console.log('🔍 Limpiando formulario de actividad');

    // 1. Limpiar variables
    this.isNewActividad = false;
    this.editableAct = false;
    this.actividadEditable = null;

    // 2. Resetear formulario
    this.activityForm.reset();

    // 3. Limpiar evidencia
    this.selectedEvidenceFile = null;
    this.evidencePreviewUrl = null;

    // 4. Cerrar menú
    this.closeMenu();

    console.log('🔍 Formulario limpiado, actividades actuales:', this.actividades);
  }

  cancelarEditableActividad() {
    // 1. Limpiar variables de edición
    this.isNewActividad = false;
    this.editableAct = false;
    this.actividadEditable = null;

    // 2. Resetear formulario
    this.activityForm.reset();

    // 3. Limpiar evidencia temporal
    this.selectedEvidenceFile = null;
    this.evidencePreviewUrl = null;

    // 4. Cerrar menú
    this.closeMenu();

    // 5. Recalcular porcentaje
    this.calcularPorcentaje();
  }

  eliminarActividad(actividad: any): void {
    this.actividadAEliminar = actividad; // Establecer la actividad a eliminar
    this.mostrarModalConfirmacionEliminacion = true; // Abrir modal de confirmación
  }

  // --- Métodos para Actividades (Responsive) ---
  agregarActividadResponsive() {
    this.actividadResponsive = {
      name: '',
      description: '',
      start: '',
      end: '',
      state: STATES_OBJECTIVES.EnProgreso.name,
    };
    this.openFormResponsive();
  }

  async editarActividadResponsive(): Promise<void> {
    console.log('🔍 Debug editarActividadResponsive - INICIO:');
    console.log('📋 Actividad responsive seleccionada:', JSON.stringify(this.selectedElement, null, 2));

    // Convertir fechas para el input
    const startDate = this.getFechaParaInput(this.selectedElement.start);
    const endDate = this.getFechaParaInput(this.selectedElement.end);

    console.log('🔍 Debug editarActividadResponsive:');
    console.log('📅 Fecha original inicio (responsive):', this.selectedElement.start);
    console.log('📅 Fecha original fin (responsive):', this.selectedElement.end);
    console.log('📅 Fecha convertida inicio (responsive):', startDate);
    console.log('📅 Fecha convertida fin (responsive):', endDate);

    this.actividadResponsive = {
      ...this.selectedElement,
      start: startDate,
      end: endDate
    };

    console.log('🔍 actividadResponsive después de asignar fechas:');
    console.log('📝 Objeto completo:', this.actividadResponsive);

    // Cargar evidencia existente si la actividad está terminada
    if (this.selectedElement.state === STATES_OBJECTIVES.Terminado.name && this.selectedElement.evidence) {
      console.log('🔍 Evidencia original (responsive):', this.selectedElement.evidence);
      const evidenceUrl = this.getEvidenceUrl(this.selectedElement.evidence);
      console.log('🔗 URL completa generada (responsive):', evidenceUrl);

      // IMPORTANTE: Establecer evidencePreviewUrl con la URL completa del backend
      this.evidencePreviewUrl = evidenceUrl;
      console.log('📸 evidencePreviewUrl establecido (responsive):', this.evidencePreviewUrl);

      // Verificar si la imagen es accesible
      const isAccessible = await this.checkImageAccessibility(evidenceUrl);
      if (!isAccessible) {
        console.warn('La imagen de evidencia no es accesible:', evidenceUrl);
        this.alert('⚠️ Advertencia: La imagen de evidencia no se puede cargar. Verifica que el servidor esté funcionando correctamente.');
      }
      this.activityForm.patchValue({ evidence: 'Evidencia existente' });
      this.selectedEvidenceFile = new File([''], 'evidencia_existente.jpg', { type: 'image/jpeg' });
    } else {
      this.selectedEvidenceFile = null;
      this.evidencePreviewUrl = null;
      this.activityForm.patchValue({ evidence: '' });
    }

    this.indexEditActividadResponsive = this.actividades.findIndex((actividad) => actividad.name === this.actividadResponsive.name);
    this.openFormResponsive();
    this.closeMenu();
  }

  guardarActividadResponsive(): void {
    // Validar fechas de la actividad
    const dateValidation = this.validateFullActivityDates(this.actividadResponsive.start, this.actividadResponsive.end);
    if (!dateValidation.valid) {
      this.alert(dateValidation.message);
      return;
    }

    // Validar que si la actividad está completada, tenga evidencia
    if (this.actividadResponsive.state === STATES_OBJECTIVES.Terminado.name) {
      if (!this.selectedEvidenceFile && !this.actividadResponsive.evidence) {
        this.alert('❌ No se puede guardar la actividad. Para marcar como terminada, debes subir una imagen de evidencia.');
        return;
      }
    }

    // Agregar evidencia si existe o preservar la existente
    if (this.selectedEvidenceFile && this.evidencePreviewUrl) {
      this.actividadResponsive.completed = this.actividadResponsive.state === STATES_OBJECTIVES.Terminado.name;
      // Para nuevas imágenes, guardar el base64 que será procesado por el backend
      this.actividadResponsive.evidence = this.evidencePreviewUrl;
    } else if (this.actividadResponsive.state === STATES_OBJECTIVES.Terminado.name && this.actividadResponsive.evidence) {
      this.actividadResponsive.completed = true;
      // Para evidencia existente, mantener la ruta relativa del backend
    } else {
      this.actividadResponsive.evidence = null;
      this.actividadResponsive.completed = false;
    }

    // Las fechas ya están en formato DD/MM/YYYY, no es necesario formatearlas
    const actividadFormateada = {
      ...this.actividadResponsive
    };

    console.log('🔍 Guardando actividad responsive con fechas formateadas:');
    console.log('📅 Start original:', this.actividadResponsive.start, '→ formateado:', actividadFormateada.start);
    console.log('📅 End original:', this.actividadResponsive.end, '→ formateado:', actividadFormateada.end);

    if (this.indexEditActividadResponsive !== null) {
      this.actividades[this.indexEditActividadResponsive] = actividadFormateada;
    } else {
      this.actividades.push(actividadFormateada);
    }
    this.actividadResponsive = null;
    this.indexEditActividadResponsive = null;
    this.selectedEvidenceFile = null;
    this.evidencePreviewUrl = null;
    this.closeFormResponsive();
    this.calcularPorcentaje();
  }

  changeFechaActividadResponsive(event: string, tipo: number): void {
    if (event) {
      if (tipo === 1) {
        this.actividadResponsive.start = event;
      } else {
        this.actividadResponsive.end = event;
      }
    }
  }

  // --- Métodos para Objetivo ---
  editarObjetivo(): void {
    this.editable = true;
  }

  guardarObjetivo(): void {
    console.log('🔍 guardarObjetivo iniciado');
    console.log('📋 newObjetivo:', this.newObjetivo);
    console.log('📋 actividadRecibida:', this.actividadRecibida);

    this.editable = false;
    if (this.editableAct) {
      this.cancelarEditableActividad();
    }

    if (!this.nombreObjetivo || !this.descripcionObjetivo || !this.selectedValue || !this.fechaInicioObjetivo || !this.fechaFinObjetivo) {
      this.alert('Por favor, completa todos los campos requeridos del objetivo.');
      return;
    }

    // Verificar que la fecha de fin sea mayor que la fecha de inicio
    let auxFechaInicioObjetivo = this.parseDDMMYYYY(this.fechaInicioObjetivo);
    let auxFechaFinObjetivo = this.parseDDMMYYYY(this.fechaFinObjetivo);

    if (!auxFechaInicioObjetivo || !auxFechaFinObjetivo) {
      return;
    }

    if (auxFechaInicioObjetivo >= auxFechaFinObjetivo) {
      this.alert('❌ La fecha de fin debe ser posterior a la fecha de inicio. Por favor, verifica las fechas seleccionadas.');
      return;
    }

    // Validar que todas las actividades terminadas tengan evidencia
    const actividadesSinEvidencia = this.actividades.filter(act =>
      act.completed && !act.evidence
    );

    if (actividadesSinEvidencia.length > 0) {
      const nombresActividades = actividadesSinEvidencia.map(act => act.name).join(', ');
      this.alert(`❌ No se puede guardar el objetivo. Las siguientes actividades están marcadas como terminadas pero no tienen evidencia: ${nombresActividades}`);
      return;
    }

    const dimension = this.optionsDimensions.find(opt => opt.id.toString() === this.selectedValue);
    if (!dimension) {
      this.alert('La dimensión seleccionada no es válida.');
      return;
    }

    // Limpiar las actividades para enviar solo rutas relativas o base64 al backend
    const cleanedActivities = this.actividades.map(activity => ({
      ...activity,
      evidence: this.cleanEvidencePath(activity.evidence)
    }));

    // Calcular el estado automáticamente basado en fechas y actividades
    const calculatedState = this.calculateObjectiveStateByDate();
    console.log('🔍 Estado calculado automáticamente:', calculatedState);
    console.log('🔍 Estado anterior:', this.estadoObjetivo);

    const objetivo: any = {
      name: this.nombreObjetivo,
      description: this.descripcionObjetivo,
      dimension: dimension,
      state: calculatedState,
      start: this.fechaInicioObjetivo,
      end: this.fechaFinObjetivo,
      activities: cleanedActivities,
      percentage: this.porcentaje,
      userId: this.authUser.id,
    };



    if (!this.newObjetivo && this.actividadRecibida && (this.actividadRecibida._id || this.actividadRecibida.id)) {
      objetivo._id = this.actividadRecibida._id || this.actividadRecibida.id;
      console.log('🔍 Editando objetivo existente - ID:', objetivo._id);
    } else {
      console.log('🔍 Creando objetivo nuevo');
      // Asegurar que no tenga ID para objetivos nuevos
      delete objetivo._id;
      delete objetivo.id;
    }

    // Validar que si es actualización, tenga ID
    if (!this.newObjetivo && !objetivo._id) {
      console.error('❌ Error: Intentando actualizar objetivo sin ID');
      console.error('❌ newObjetivo:', this.newObjetivo);
      console.error('❌ actividadRecibida:', this.actividadRecibida);
      console.error('❌ objetivo:', objetivo);
      this.alert('Error: No se encontró el ID del objetivo para actualizar.');
      return;
    }

    const serviceCall = this.newObjetivo
      ? this.objectiveService.createObjective(objetivo)
      : this.objectiveService.updateObjective(objetivo);

    serviceCall.subscribe({
      next: (response) => {
        console.log('✅ Objetivo guardado exitosamente:', response);

        // Si es una actualización, actualizar el array local con las rutas procesadas por el backend
        if (!this.newObjetivo && response.data && response.data.activities) {
          this.actividades = response.data.activities;
          console.log('🔄 Actividades actualizadas con rutas del backend:', this.actividades);
        }

        // Mostrar modal de éxito en lugar de navegar directamente
        this.mostrarModalExito = true;
      },
      error: (err) => {
        console.error('❌ Error al guardar el objetivo:', err);
        this.alert('Error al guardar el objetivo. Por favor, inténtalo de nuevo.');
      },
    });
  }

  cancelar(): void {
    this.router.navigate(['/dashboard/objectives']);
  }

  // Métodos para el modal de confirmación
  mostrarModalConfirmacion(): void {
    this.mostrarModal = true;
  }

  cerrarModal(): void {
    this.mostrarModal = false;
  }

  salirSinGuardar(): void {
    this.mostrarModal = false;
    this.router.navigate(['/dashboard/objectives']);
  }

  guardarYSalir(): void {
    this.mostrarModal = false;
    //this.guardarObjetivo();
  }

  // --- Métodos de UI y de Servicio ---
  openMenu(event: MouseEvent, element: any): void {
    this.selectedElement = element;
    this.selectedButton = event.currentTarget as HTMLElement;
    this.updateMenuPosition();
  }

  private updateMenuPosition(): void {
    if (this.selectedButton) {
      const rect = this.selectedButton.getBoundingClientRect();
      this.menuPosition = {
        top: `${rect.bottom + window.scrollY}px`,
        left: `${rect.left + window.scrollX}px`,
      };
    }
  }

  closeMenu(): void {
    this.selectedElement = null;
    this.selectedButton = null;
  }

  getDimensions(): void {
    this.loader.show();
    this.testService.getDimensions().subscribe({
      next: (res: any) => {
        this.optionsDimensions = res.data;
        this.loader.hide();
      },
      error: (error: any) => {
        console.error('Error al obtener dimensiones:', error);
        this.loader.hide();
      }
    });
  }

  onSelectionChange(event: any) {
    this.selectedValue = event.target.value;
    this.isDimensionSelected = true;
  }

  openFormResponsive(): void {
    this.isOpenFormResponsive = true;
  }

  closeFormResponsive(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.actividadResponsive = null;
      this.isOpenFormResponsive = false;
      this.isClosing = false;
      this.indexEditActividadResponsive = null;
    }, 300);
  }

  calcularPorcentaje() {
    if (this.actividades.length === 0) {
      this.porcentaje = 0;
      return;
    }
    const terminadas = this.actividades.filter(act => act.state === STATES_OBJECTIVES.Terminado.name).length;
    this.porcentaje = Math.round((terminadas / this.actividades.length) * 100);
  }

  toggleActivityCompletion(actividad: any): void {
    // Si se está marcando como terminada y no tiene evidencia
    if (!actividad.completed && (!actividad.evidence || actividad.evidence.trim() === '')) {
      // Abrir modal para adjuntar evidencia
      this.openEvidenceModal(actividad);
      return;
    }

    actividad.completed = !actividad.completed;
    actividad.state = actividad.completed ? STATES_OBJECTIVES.Terminado.name : STATES_OBJECTIVES.EnProgreso.name;

    // Si se está desmarcando como terminada, limpiar evidencia
    if (!actividad.completed) {
      actividad.evidence = null;
    }

    this.calcularPorcentaje();
  }

  // Abrir modal para adjuntar evidencia
  openEvidenceModal(actividad: any) {
    this.currentActivity = actividad;
    this.showEvidenceModal = true;
    this.evidenceFile = null;
    this.evidencePreview = null;
    this.evidenceFileName = '';
  }

  // Cerrar modal de evidencia
  closeEvidenceModal() {
    this.showEvidenceModal = false;
    this.currentActivity = null;
    this.evidenceFile = null;
    this.evidencePreview = null;
    this.evidenceFileName = '';
    this.isUploading = false;
  }

  // Manejar selección de archivo de evidencia
  onEvidenceFileSelected(event: any, actividad?: any) {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
    if (!validTypes.includes(file.type)) {
      this.alert('❌ Solo se permiten archivos de imagen (JPG, PNG, GIF) o PDF');
      return;
    }

    // Validar tamaño (10MB para PDF, 5MB para imágenes)
    const maxSize = file.type === 'application/pdf' ? 10 * 1024 * 1024 : 5 * 1024 * 1024;
    if (file.size > maxSize) {
      const sizeLimit = file.type === 'application/pdf' ? '10MB' : '5MB';
      this.alert(`❌ El archivo es demasiado grande. Tamaño máximo: ${sizeLimit}`);
      return;
    }

    // Si es para el modal de evidencia (currentActivity existe)
    if (this.currentActivity && !actividad) {
      // Caso del modal
      this.evidenceFile = file;
      this.evidenceFileName = file.name;

      // Crear preview
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.evidencePreview = e.target?.result as string;
        };
        reader.readAsDataURL(file);
      } else if (file.type === 'application/pdf') {
        this.evidencePreview = 'pdf';
      }
    }
    // Si es para una actividad existente en la lista
    else if (actividad) {
      // Convertir archivo a base64 y asignarlo directamente a la actividad
      this.fileToBase64(file).then((base64) => {
        actividad.evidence = base64;
        this.alert('✅ Evidencia adjuntada correctamente');
      }).catch((error) => {
        console.error('Error al procesar evidencia:', error);
        this.alert('❌ No se pudo procesar la evidencia. Inténtalo de nuevo.');
      });
    }
  }

  // Método para obtener el tipo de archivo
  getFileType(evidence: string): string {
    if (!evidence) return 'none';
    if (evidence === 'pdf' || evidence.toLowerCase().includes('pdf')) return 'pdf';
    return 'image';
  }

  // Confirmar y guardar evidencia
  confirmEvidenceAndComplete() {
    if (!this.evidenceFile || !this.currentActivity) return;

    this.isUploading = true;

    // Convertir archivo a base64
    this.fileToBase64(this.evidenceFile).then((base64) => {
      // Actualizar la actividad con la evidencia
      this.currentActivity.evidence = base64;
      this.currentActivity.completed = true;
      this.currentActivity.state = STATES_OBJECTIVES.Terminado.name;

      // Recalcular porcentaje
      this.calcularPorcentaje();

      this.closeEvidenceModal();
      this.alert('✅ Actividad completada con evidencia adjunta');
    }).catch((error) => {
      console.error('Error al procesar evidencia:', error);
      this.alert('❌ No se pudo procesar la evidencia. Inténtalo de nuevo.');
    }).finally(() => {
      this.isUploading = false;
    });
  }

  // Convertir archivo a base64
  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // Descargar archivo de evidencia
  downloadEvidenceFile() {
    if (!this.evidenceFile) return;

    try {
      // Crear URL para descarga
      const url = URL.createObjectURL(this.evidenceFile);

      // Crear elemento anchor para descarga
      const link = document.createElement('a');
      link.href = url;
      link.download = this.evidenceFileName;
      link.style.display = 'none';

      // Agregar al DOM, hacer clic y remover
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Limpiar URL
      URL.revokeObjectURL(url);

      this.success('Archivo descargado exitosamente');
    } catch (error) {
      console.error('Error al descargar archivo:', error);
      this.alert('Error al descargar el archivo');
    }
  }

  toggleNewActivityState(): void {
    // 1. Obtener estado actual
    const estadoActual = this.activityForm.get('state')?.value;

    // 2. Calcular nuevo estado (toggle)
    const nuevoEstado = estadoActual === STATES_OBJECTIVES.Terminado.name
      ? STATES_OBJECTIVES.EnProgreso.name
      : STATES_OBJECTIVES.Terminado.name;

    // 3. Actualizar formulario con estado y completed
    const isCompleted = nuevoEstado === STATES_OBJECTIVES.Terminado.name;
    this.activityForm.patchValue({
      state: nuevoEstado,
      completed: isCompleted
    });

    // 4. Configurar validación
    if (nuevoEstado === STATES_OBJECTIVES.Terminado.name) {
      this.activityForm.get('evidence')?.setValidators([Validators.required]);
      this.activityForm.get('evidence')?.updateValueAndValidity();
      this.alert('✅ Actividad marcada como terminada. Ahora debes subir una imagen de evidencia para poder guardar.');
    } else {
      this.activityForm.get('evidence')?.clearValidators();
      this.activityForm.get('evidence')?.updateValueAndValidity();

      // Limpiar evidencia
      this.selectedEvidenceFile = null;
      this.evidencePreviewUrl = null;
      this.activityForm.patchValue({ evidence: '' });
      this.alert('ℹ️ Actividad marcada como pendiente. La evidencia ya no es requerida.');
    }
  }



  private compressImage(file: File): void {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      // Calcular nuevas dimensiones (máximo 800px de ancho o alto)
      const maxSize = 800;
      let { width, height } = img;

      if (width > height) {
        if (width > maxSize) {
          height = (height * maxSize) / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width = (width * maxSize) / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Dibujar imagen comprimida
      ctx?.drawImage(img, 0, 0, width, height);

      // Convertir a base64 con calidad 0.8
      const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.8);
      this.evidencePreviewUrl = compressedDataUrl;
    };

    img.onerror = (error) => {
      console.error('Error al cargar la imagen:', error);
    };

    img.src = URL.createObjectURL(file);
  }

  private compressImageForActivity(file: File, actividad: any): void {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      // Calcular nuevas dimensiones (máximo 800px de ancho o alto)
      const maxSize = 800;
      let { width, height } = img;

      if (width > height) {
        if (width > maxSize) {
          height = (height * maxSize) / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width = (width * maxSize) / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Dibujar imagen comprimida
      ctx?.drawImage(img, 0, 0, width, height);

      // Convertir a base64 con calidad 0.8
      const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.8);
      actividad.evidence = compressedDataUrl;

      // Si la actividad está marcada como terminada, permitir el toggle
      if (actividad.state === STATES_OBJECTIVES.Terminado.name) {
        actividad.completed = true;
      }
    };

    img.onerror = (error) => {
      console.error('Error al cargar la imagen:', error);
    };

    img.src = URL.createObjectURL(file);
  }

  removeEvidence(actividad?: any): void {
    if (actividad) {
      // Remover evidencia de actividad existente
      actividad.evidence = null;
      // Si la actividad está marcada como terminada, desmarcarla
      if (actividad.completed) {
        actividad.completed = false;
        actividad.state = STATES_OBJECTIVES.EnProgreso.name;
        this.calcularPorcentaje();
      }
    } else {
      // Remover evidencia del formulario de nueva actividad
      this.selectedEvidenceFile = null;
      this.evidencePreviewUrl = null;
      this.activityForm.patchValue({ evidence: '' });
    }
  }

  getFileSize(file: File | null): string {
    if (!file) return '';

    const bytes = file.size;
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }



  // Método para verificar si se puede guardar la actividad
  canSaveActivity(): boolean {
    const formValue = this.activityForm.value;

    // Si el formulario es inválido, no se puede guardar
    if (this.activityForm.invalid) {
      return false;
    }

    if (formValue.name.length > 100) {
      console.log("name > 100: ", formValue.name.length, formValue.name)
      return false;
    }

    // Si la actividad está marcada como terminada, debe tener evidencia
    if (formValue.state === STATES_OBJECTIVES.Terminado.name) {
      const hasEvidence = !!(this.selectedEvidenceFile || this.evidencePreviewUrl || this.actividadEditable?.evidence);
      return hasEvidence;
    }

    return true;
  }

  // Método para verificar si se puede guardar el objetivo
  canSaveObjective(): boolean {
    // Verificar campos básicos del objetivo
    if (!this.nombreObjetivo || !this.descripcionObjetivo || !this.selectedValue || !this.fechaInicioObjetivo || !this.fechaFinObjetivo) {
      return false;
    }

    // Verificar que la fecha de fin sea mayor que la fecha de inicio
    let auxFechaInicioObjetivo = this.parseDDMMYYYY(this.fechaInicioObjetivo);
    let auxFechaFinObjetivo = this.parseDDMMYYYY(this.fechaFinObjetivo);

    if (!auxFechaInicioObjetivo || !auxFechaFinObjetivo) {
      return false;
    }
    
    if (auxFechaInicioObjetivo >= auxFechaFinObjetivo) {
      return false;
    }

    // Solo verificar evidencia si hay actividades
    if (this.actividades && this.actividades.length > 0) {
      // Verificar que todas las actividades terminadas tengan evidencia
      const actividadesSinEvidencia = this.actividades.filter(act =>
        act.completed && !act.evidence
      );

      return actividadesSinEvidencia.length === 0;
    }

    // Si no hay actividades, se puede guardar el objetivo
    return true;
  }

  // Método para obtener la fecha actual en formato YYYY-MM-DD
  getCurrentDate(): string {
    // Crear fecha local sin problemas de zona horaria
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const result = `${year}-${month}-${day}`;
    return result;
  }

  // Métodos para obtener los límites de fecha para date picker de OBJETIVO
  getLimitRangeCalendarObjectiveStart(): DateRange<Date> {
    let newLimitRangeCalendar: DateRange<Date> = new DateRange<Date>(null, null);
    const min = new Date();
    newLimitRangeCalendar = new DateRange<Date>(min, null);
    return newLimitRangeCalendar;
  }

  getLimitRangeCalendarObjectiveEnd(): DateRange<Date> {
    let newLimitRangeCalendar: DateRange<Date> = new DateRange<Date>(null, null);
    const min = this.parseDDMMYYYY(this.fechaInicioObjetivo);
    newLimitRangeCalendar = new DateRange<Date>(min, null);
    return newLimitRangeCalendar;
  }

  getLimitRangeCalendarActivityStart(): DateRange<Date> {
    const min = this.parseDDMMYYYY(this.fechaInicioObjetivo);
    const max = this.parseDDMMYYYY(this.fechaFinObjetivo);
    return new DateRange<Date>(min, max);
  }

  getLimitRangeCalendarActivityEnd(): DateRange<Date> {
    const min = this.parseDDMMYYYY(this.activityForm.get('start')?.value);
    const max = this.parseDDMMYYYY(this.fechaFinObjetivo);
    return new DateRange<Date>(min, max);
  }

  parseDDMMYYYY(dateStr: string): Date | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }

  // Métodos para manejar el modal de éxito
  cerrarModalExito(): void {
    this.mostrarModalExito = false;
    this.router.navigate(['/dashboard/objectives']);
  }

  guardarYContinuar(): void {
    this.mostrarModalExito = false;
    this.router.navigate(['/dashboard/objectives']);
  }

  // Métodos de validación para fechas de actividades
  validateActivityStartDate(startDate: string): boolean {
    let auxFechaInicioObjetivo = this.parseDDMMYYYY(this.fechaInicioObjetivo);
    let auxStartDate = this.parseDDMMYYYY(startDate);
    if (!auxFechaInicioObjetivo || !auxStartDate) return true;
    return auxFechaInicioObjetivo <= auxStartDate;
  }

  validateActivityEndDate(endDate: string): boolean {
    let auxFechaFinObjetivo = this.parseDDMMYYYY(this.fechaFinObjetivo);
    let auxEndDate = this.parseDDMMYYYY(endDate);
    if (!auxFechaFinObjetivo || !auxEndDate) return true;
    return auxEndDate <= auxFechaFinObjetivo;
  }

  validateActivityDateRange(startDate: string, endDate: string): boolean {
    console.log("validateActivityDateRange:", startDate, endDate);
    let auxStartDate = this.parseDDMMYYYY(startDate);
    let auxEndDate = this.parseDDMMYYYY(endDate);
    console.log("validateActivityDateRange:", auxStartDate, auxEndDate);
    if (!auxStartDate || !auxEndDate) return true;
    return auxStartDate <= auxEndDate;
  }

  validateFullActivityDates(startDate: string, endDate: string): { valid: boolean; message: string } {
    // Validar que las fechas estén definidas
    if (!startDate || !endDate) {
      return { valid: false, message: 'Las fechas de inicio y fin son obligatorias' };
    }

    let auxStartDate = this.parseDDMMYYYY(startDate);
    let auxEndDate = this.parseDDMMYYYY(endDate);
    let auxFechaInicioObjetivo = this.parseDDMMYYYY(this.fechaInicioObjetivo);
    let auxFechaFinObjetivo = this.parseDDMMYYYY(this.fechaFinObjetivo);

    if (!auxStartDate || !auxEndDate || !auxFechaInicioObjetivo || !auxFechaFinObjetivo) {
      return { valid: false, message: 'Error al convertir las fechas. Ponerse en contacto con un admin.' };
    }

    // Validar que la fecha de inicio sea posterior a la fecha de inicio del objetivo
    if (auxStartDate < auxFechaInicioObjetivo) {
      return { valid: false, message: `La fecha de inicio debe ser posterior o igual a ${auxFechaFinObjetivo}` };
    }

    // Validar que la fecha de fin sea anterior a la fecha de fin del objetivo
    if (auxEndDate > auxFechaFinObjetivo) {
      return { valid: false, message: `La fecha de fin debe ser anterior o igual a ${auxFechaFinObjetivo}` };
    }

    // Validar que la fecha de fin sea posterior o igual a la fecha de fin
    if (auxStartDate > auxEndDate) {
      return { valid: false, message: 'La fecha de fin debe ser posterior o igual a la fecha de inicio' };
    }

    return { valid: true, message: '' };
  }


  // Método para obtener las fechas mínimas y máximas para actividades
  getActivityMinStartDate(): string {
    // Siempre recalcular para asegurar que refleje la fecha actual del objetivo
    const fechaInicio = this.fechaInicioObjetivo;
    const currentDate = this.getCurrentDate();

    // Si no hay fecha de inicio del objetivo, usar la fecha actual
    if (!fechaInicio) {
      return currentDate;
    }

    // Convertir ambas fechas para comparar
    const fechaInicioConvertida = this.getFechaParaInput(fechaInicio);

    // Usar la fecha que sea menor (más temprana) entre la fecha actual y la fecha de inicio del objetivo
    // Esto permite crear actividades desde hoy si el objetivo comienza en el futuro
    const result = fechaInicioConvertida <= currentDate ? fechaInicioConvertida : currentDate;

    return result;
  }

  getActivityMaxStartDate(): string {
    // Siempre recalcular para asegurar que refleje la fecha actual del objetivo
    const fechaFin = this.fechaFinObjetivo;
    return fechaFin ? this.getFechaParaInput(fechaFin) : '';
  }

  getActivityMinEndDate(activityStartDate?: string): string {
    // Si hay fecha de inicio de actividad, la fecha mínima de fin es el día siguiente
    if (activityStartDate) {
      try {
        const dateObj = new Date(activityStartDate);
        if (!isNaN(dateObj.getTime())) {
          const nextDay = new Date(dateObj);
          nextDay.setDate(nextDay.getDate() + 1);
          return nextDay.toISOString().split('T')[0];
        }
      } catch (error) {
        // Si hay error, usar la fecha de inicio del objetivo
      }
    }

    // Si no hay fecha de inicio de actividad, usar la fecha de inicio del objetivo
    const fechaInicio = this.fechaInicioObjetivo;
    return fechaInicio ? this.getFechaParaInput(fechaInicio) : this.getCurrentDate();
  }

  getActivityMaxEndDate(): string {
    // Siempre recalcular para asegurar que refleje la fecha actual del objetivo
    const fechaFin = this.fechaFinObjetivo;
    return fechaFin ? this.getFechaParaInput(fechaFin) : '';
  }

  // Función para obtener la fecha máxima de la fecha de inicio (para bloquear fechas anteriores)
  getActivityMaxStartDateForEndDate(activityStartDate?: string): string {
    if (!this._activityMaxStartDateForEndDate) {
      const startDate = activityStartDate || this.activityForm.get('start')?.value;

      if (startDate) {
        // La fecha máxima para la fecha de fin debe ser la fecha de inicio
        // Esto bloqueará todas las fechas desde el 1 hasta la fecha de inicio inclusive
        this._activityMaxStartDateForEndDate = this.getFechaParaInput(startDate);
      } else {
        this._activityMaxStartDateForEndDate = this.getFechaParaInput(this.fechaInicioObjetivo) || this.getCurrentDate();
      }
    }

    return this._activityMaxStartDateForEndDate;
  }

  // --- Métodos para contador de caracteres ---
  getCharacterCount(text: string): number {
    return text ? text.length : 0;
  }

  getRemainingCharacters(text: string, max: number): number {
    return max - this.getCharacterCount(text);
  }

  getCharacterCountText(text: string, max: number): string {
    const current = this.getCharacterCount(text);
    return `${current}/${max}`;
  }

  isCharacterLimitExceeded(text: string, max: number): boolean {
    return this.getCharacterCount(text) > max;
  }

  isNearCharacterLimit(text: string, max: number): boolean {
    const remaining = this.getRemainingCharacters(text, max);
    return remaining <= 20 && remaining > 0;
  }

  // Métodos para el modal de confirmación de eliminación
  confirmarEliminacionActividad(): void {
    if (this.actividadAEliminar) {
      // Eliminar la actividad confirmada
      this.actividades = this.actividades.filter((act) => act !== this.actividadAEliminar);
      this.calcularPorcentaje();

      // Cerrar modal y limpiar
      this.cerrarModalConfirmacionEliminacion();

      // Mostrar mensaje de éxito
      this.alert('✅ Actividad eliminada correctamente');
    }
  }

  cerrarModalConfirmacionEliminacion(): void {
    this.mostrarModalConfirmacionEliminacion = false;
    this.actividadAEliminar = null;
  }

  // Métodos para calcular el estado del objetivo basado en fechas y actividades
  calculateObjectiveStateByDate(): string {
    // Si el objetivo ya está marcado como eliminado, mantener ese estado
    if (this.estadoObjetivo === STATES_OBJECTIVES.Eliminado.name) {
      return STATES_OBJECTIVES.Eliminado.name;
    }

    // Si el objetivo está completado (100% o todas las actividades terminadas), es Terminado
    if (this.porcentaje === 100 || this.areAllActivitiesCompleted()) {
      return STATES_OBJECTIVES.Terminado.name;
    }

    // Obtener fecha actual
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Convertir fecha de fin del objetivo
    const endDateStr = this.fechaFinObjetivo;
    let endDate: Date;

    if (endDateStr.includes('/')) {
      // Formato DD/MM/YYYY
      const [day, month, year] = endDateStr.split('/').map(Number);
      endDate = new Date(year, month - 1, day);
    } else {
      // Formato ISO o YYYY-MM-DD
      endDate = new Date(endDateStr);
    }

    endDate.setHours(0, 0, 0, 0);

    // Calcular diferencia en días
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Si tiene actividades en progreso, está En progreso
    if (this.hasActivitiesInProgress()) {
      // Si ya pasó la fecha de fin, está Atrasado
      if (diffDays < 0) {
        return STATES_OBJECTIVES.Atrasado.name;
      }
      // Si está dentro del plazo, está En progreso
      return STATES_OBJECTIVES.EnProgreso.name;
    }

    // Si no tiene actividades en progreso
    if (diffDays < 0) {
      // Ya pasó la fecha, está Atrasado
      return STATES_OBJECTIVES.Atrasado.name;
    } else if (diffDays <= 7) {
      // Falta una semana o menos, está Por vencer
      return STATES_OBJECTIVES.PorVencer.name;
    } else {
      // Aún tiene tiempo, está En progreso (pendiente de empezar)
      return STATES_OBJECTIVES.EnProgreso.name;
    }
  }

  private areAllActivitiesCompleted(): boolean {
    if (!this.actividades || this.actividades.length === 0) {
      return false;
    }
    return this.actividades.every(actividad => actividad.completed);
  }

  private hasActivitiesInProgress(): boolean {
    if (!this.actividades || this.actividades.length === 0) {
      return false;
    }
    return this.actividades.some(actividad => actividad.completed === false);
  }

  /**
   * Carga los datos del usuario
   */
  private loadUserData(): void {
    this.authService.findUserById(this.authUser.id).subscribe({
      next: (userResponse) => {
        if (userResponse && userResponse.data) {
          this.user = userResponse.data;
        }
      },
      error: (error) => {
        console.error('Error al cargar datos del usuario:', error);
      }
    });
  }

  /**
   * Verifica si el usuario es Executive
   */
  isExecutiveUser(): boolean {
    return !!(
      this.user &&
      this.user.type &&
      this.user.type.id === 1 && // Customer
      this.user.type.suscriptionType &&
      this.user.type.suscriptionType.id === SUBSCRIPTION_TYPES.Executive.id.toString()
    );
  }

  openModalCalendar(assignToCalendar: string, assingToDate: string, limitsRangeCalendar: DateRange<Date> = new DateRange<Date>(null, null)) {
    // validate "assignToCalendar" and "assingToDate"'s values
    const allowedModes = ['objective start', 'objective end', 'activity start', 'activity end'];
    if (!allowedModes.includes(assignToCalendar + ' ' + assingToDate)) return;

    this.assignToCalendar = assignToCalendar;
    this.assingToDate = assingToDate;
    this.limitsRangeCalendar = limitsRangeCalendar;
    this.showModalCalendar = true;
  }

  closeModalCalendar() {
    this.showModalCalendar = false;
    this.modalCalendarValue = null;
    this.assignToCalendar = '';
    this.assingToDate = '';
    this.limitsRangeCalendar = new DateRange<Date>(null, null);
  }

  confirmModalCalendar() {
    if (!this.modalCalendarValue) return;

    const formattedDate: string = this.formatDate(this.modalCalendarValue);

    switch (this.assignToCalendar + ' ' + this.assingToDate) {
      case "objective start":
        this.fechaInicioObjetivo = formattedDate;
        this.fechaFinObjetivo = '';
        break;
      case "objective end":
        this.fechaFinObjetivo = formattedDate;
        break;
      case "activity start":
        this.activityForm.patchValue({
          start: formattedDate,
          end: ''
        });
        break;
      case "activity end":
        this.activityForm.patchValue({
          end: formattedDate
        });
        break;
      default:
        return;
    }
    this.closeModalCalendar();
  }

  onSelectedChange(date: Date) {
    this.modalCalendarValue = date;
  }

  private formatDate(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
